<template>
  <div class="calico-meter-page">
    <div class="calico-meter-container">
      <div class="calico-meter-row">
        <div class="parent">
          <ClicoMeter color="#FFFFFF40" />
        </div>
        <div class="parent">
          <ClicoMeter
            percentage="10"
            color="#8B0E38"
          />
        </div>
        <div class="parent">
          <ClicoMeter
            percentage="30"
            color="#FF5C00"
          />
        </div>
        <div class="parent">
          <ClicoMeter
            percentage="50"
            color="#E9FA20"
          />
        </div>
        <div class="parent">
          <ClicoMeter
            percentage="60"
            color="#FF03BE"
          />
        </div>
      </div>
      <div class="calico-meter-row">
        <div class="parent">
          <ClicoMeter
            percentage="70"
            color="#4C00E0"
          />
        </div>
        <div class="parent">
          <ClicoMeter
            percentage="80"
            color="#21D8CF"
          />
        </div>
        <div class="parent">
          <ClicoMeter
            percentage="90"
            color="#0EF180"
          />
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script lang="js">
  import ClicoMeter from '@/components/calico/meter/index.vue'
  export default {
    name: 'ClicoMeterPage',
    components: {
      ClicoMeter
    },
  }
  </script>
  <style lang="scss">
  .calico-meter-page {
    display: flex;
    height: 100vh;
    background: gray;
    .calico-meter-container {
      @include stack-space($space-large);
      width: 100%;
      .calico-meter-row {
        @include inline-space($space-large);
        width: 100%;
        .parent {
          position: relative;
          width: 150px;
          height: 150px;
        }
      }
    }
  }
  </style>
  